export default "__VITE_ASSET__Btv4MA1W__"